import { Component, computed, input, output } from "@angular/core";
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";


import { PortalRequestStatus } from "../../enums";

const Status = PortalRequestStatus
type Status = PortalRequestStatus

@Component({
	selector: 'portal-request-status-button',
	imports: [
		RouterModule,
		TranslateModule,
		NgbDropdownModule
	],
	template: `
		<div ngbDropdown placement="bottom-right">
			@if (href()) {
				<a
					[routerLink]="href()"
					class="btn {{ currentStatusClass() }}"
					[translate]="'PortalRequests.Status.' + request().portalRequestStatus"
				></a>
			} @else {
				@if (disabled() || locked()) {
					<button class="btn {{ currentStatusClass() }}" [disabled]="disabled() || locked()" data-cy="DropdownToggle">
						{{ 'PortalRequests.Status.' + request().portalRequestStatus | translate }}
					</button>
				} @else {
					<button ngbDropdownToggle class="btn {{ currentStatusClass() }}" [disabled]="disabled() || locked()" data-cy="DropdownToggle">
						{{ 'PortalRequests.Status.' + request().portalRequestStatus | translate }}
					</button>
				}
				@if (!disabled() && !locked()) {
					<div class="dropdown-menu" ngbDropdownMenu>
						<button
							ngbDropdownItem
							translate="PortalRequests.Status.Approved"
							(click)="selectStatus.emit(Status.Approved)"
						></button>
						<button
							ngbDropdownItem
							translate="PortalRequests.Status.Refused"
							(click)="selectStatus.emit(Status.Refused)"
						></button>
					</div>
				}
			}
		</div>
	`,
})
export class PortalRequestStatusButtonComponent {
	Status = Status
	
	selectStatus = output<Status>()
	request = input.required<{ portalRequestStatus: Status }>()
	disabled = input(false)
	href = input('')

	locked = computed(() => this.request().portalRequestStatus !== Status.Requested)
	currentStatusClass = computed(() => ({
		[Status.Approved]: `alert alert-success`,
		[Status.Refused]: `alert alert-danger`,
		[Status.Requested]: `alert alert-info`,
	}[this.request().portalRequestStatus]))
}